import { render, staticRenderFns } from "./final-list.vue?vue&type=template&id=fafed55e"
import script from "./final-list.vue?vue&type=script&lang=js"
export * from "./final-list.vue?vue&type=script&lang=js"
import style0 from "./final-list.vue?vue&type=style&index=0&id=fafed55e&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports